import React from 'react';
import '../css/style.css'; // Previously: './TermOfUse.css';

const TermOfUse = () => {
    return (
        <div className="term-of-use-page">
            {/* Header slika */}
            <div
                className="header-image"
                style={{
                    backgroundImage: `url(/images/default.jpg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '300px',
                    width: '100vw',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div className="page-title-container" style={{
                    backgroundColor: 'hsl(0, 0.00%, 100.00%)',
                    padding: '10px 20px',
                    borderRadius: '8px',
                }}>
                    <h1 className="page-title" style={{
                        color: '#000000',
                        fontSize: '28px',
                        fontFamily: 'Montserrat, sans-serif',
                    }}>Terms of Use</h1>
                </div>
            </div>

            {/* Razmak između headera i sadržaja */}
            <div style={{ height: '20px', backgroundColor: '#f8f9fa' }}></div>

            {/* Centralna sekcija sa uslovima korišćenja */}
            <div className="terms-content-box" style={{
                padding: '50px 20px',
                fontFamily: 'Montserrat, sans-serif',
                lineHeight: '1.8',
                color: '#333',
                maxWidth: '800px',
                margin: '0 auto',
            }}>
                <div className="terms-details">
                    <h2 style={{
                        fontSize: '28px',
                        color: '#007BFF',
                        marginBottom: '20px',
                    }}>Welcome to Tooristico</h2>
                    <p>
                        By accessing or using our website, you agree to be bound by the following terms and conditions.
                        Please read them carefully. If you do not agree with these terms, please refrain from using our
                        services.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>1. General Terms</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam consequat lectus eu lectus
                        vehicula, vel tincidunt nunc luctus.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>2. Intellectual Property</h3>
                    <p>
                        All content provided on this website, including text, graphics, logos, and images, is the property
                        of Tooristico and is protected by copyright laws.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>3. User Responsibilities</h3>
                    <p>
                        Users agree not to misuse the website or its services in any way. This includes refraining from
                        illegal activities or actions that may harm the website's functionality.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>4. Liability Disclaimer</h3>
                    <p>
                        Tooristico is not responsible for any damages or losses resulting from the use of this website.
                        Users access and use the site at their own risk.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>5. Changes to Terms</h3>
                    <p>
                        We reserve the right to update or modify these terms at any time. Continued use of the website
                        implies acceptance of the updated terms.
                    </p>

                    <h3 style={{
                        fontSize: '22px',
                        marginTop: '30px',
                        color: '#007BFF',
                    }}>6. Contact Us</h3>
                    <p>
                        For any questions or concerns regarding these terms, feel free to contact us:
                    </p>
                    <p><strong>Email:</strong> terms@tooristico.com</p>
                    <p><strong>Phone:</strong> +1 (123) 456-7890</p>
                </div>
            </div>
        </div>
    );
};

export default TermOfUse;
